import { Directive, ElementRef, Input, OnInit } from '@angular/core';
import { AuthenticationService } from '../components/pages/authentication/authentication/authentication.service';
import { PermissionTypeEnum } from '../common/permission-enum';

@Directive({
	selector: '[notPartner]'
})
export class NotPartnerDirective implements OnInit {

	constructor(
		private element: ElementRef,
		private authService: AuthenticationService
	) {
	}

	ngOnInit(): void {
		if (this.authService.isPartner() === false && this.authService.getUser().userPartner === false) {
			return;
		}
		this.element.nativeElement?.remove();
	}
}
